(function () {
  var GREEN = '#3caf00';
  var OLD = '#94a3b8';

  function setImportant(el, prop, value) {
    if (!el || !el.style) return;
    el.style.setProperty(prop, value, 'important');
  }

  function fixPrices(root) {
    var scope = root || document;
    var priceSelectors = [
      '.price-item--regular',
      '.price__regular',
      '.price:not(.price--on-sale)',
      '.product-price',
      '.productListing .price:not(.price--on-sale)',
      '.productListing .price__regular',
      '.productListing .price__last',
      '.productListing .price-item',
      '.productListing .price-item--regular',
      '.productListing .price-item--sale',
      '.productListing .money',
      '.products-grid .price:not(.price--on-sale)',
      '.products-grid .price__regular',
      '.products-grid .price__last',
      '.products-grid .price-item',
      '.products-grid .price-item--regular',
      '.products-grid .price-item--sale',
      '.products-grid .money',
      '.product-item .price:not(.price--on-sale)',
      '.product-item .price__regular',
      '.product-item .price__last',
      '.product-item .price-item',
      '.product-item .price-item--regular',
      '.product-item .price-item--sale',
      '.product-item .money',
      '.card-information .price:not(.price--on-sale)',
      '.card-information .price__regular',
      '.card-information .price__last',
      '.card-information .price-item',
      '.card-information .price-item--regular',
      '.card-information .price-item--sale',
      '.card-information .money'
    ];

    scope.querySelectorAll(priceSelectors.join(',')).forEach(function (el) {
      if (el.closest('.price__compare, s, .price__saved, .price-item--saved, .old-price, .compare-price')) return;
      setImportant(el, 'color', GREEN);
      setImportant(el, '-webkit-text-fill-color', GREEN);
    });

    scope.querySelectorAll([
      '.productListing .price__compare',
      '.productListing .price__compare *',
      '.productListing s',
      '.productListing s *',
      '.products-grid .price__compare',
      '.products-grid .price__compare *',
      '.products-grid s',
      '.products-grid s *',
      '.product-item .price__compare',
      '.product-item .price__compare *',
      '.product-item s',
      '.product-item s *',
      '.card-information .price__compare',
      '.card-information .price__compare *',
      '.card-information s',
      '.card-information s *'
    ].join(',')).forEach(function (el) {
      setImportant(el, 'color', OLD);
      setImportant(el, '-webkit-text-fill-color', OLD);
      setImportant(el, 'text-decoration-color', OLD);
    });

    scope.querySelectorAll([
      '.price__saved',
      '.price__saved *',
      '.price-item--saved',
      '.discounts__discount',
      '.discounts__discount *',
      '.badge.sale-badge',
      '.sale-badge'
    ].join(',')).forEach(function (el) {
      setImportant(el, 'color', '#fff');
      setImportant(el, '-webkit-text-fill-color', '#fff');
    });
  }

  function hideVideoPlayOverlays(root) {
    var scope = root || document;
    scope.querySelectorAll([
      '.productView .productView-images-wrapper button:not(.capsule-gallery-arrow)',
      '.productView .productView-images-wrapper .button:not(.capsule-gallery-arrow)',
      '.productView .productView-images-wrapper [role="button"]:not(.capsule-gallery-arrow)',
      '.productView .productView-images-wrapper a[aria-label*="play" i]',
      '.productView .productView-images-wrapper a[aria-label*="reproduzir" i]',
      '.productView .productView-images-wrapper a[class*="play" i]',
      '.productView .productView-images-wrapper span[class*="play" i]',
      '.productView .productView-images-wrapper div[class*="play" i]',
      '.productView .productView-images-wrapper .deferred-media__poster-button',
      '.productView .productView-images-wrapper .productView-video-icon',
      '.productView .productView-images-wrapper .video-icon',
      '.productView .productView-images-wrapper .media-icon--play',
      '.productView .productView-images-wrapper button[aria-label*="play" i]',
      '.productView .productView-images-wrapper button[aria-label*="reproduzir" i]',
      '.productView .productView-images-wrapper [class*="play" i]',
      '.productView .capsule-gallery-thumbs button:not(.capsule-gallery-arrow)',
      '.productView .capsule-gallery-thumbs svg',
      '.productView .capsule-gallery-thumbs i',
      '.productView .capsule-gallery-thumbs .icon',
      '.productView .capsule-gallery-thumbs [class*="play" i]',
      '.productView .capsule-gallery-thumbs [class*="media-icon" i]',
      '.productView .deferred-media__poster-button',
      '.productView .productView-video-icon',
      '.productView .video-icon',
      '.productView .media-icon--play',
      '.productView button[aria-label*="play" i]',
      '.productView button[aria-label*="reproduzir" i]',
      '.productView [class*="play" i]'
    ].join(',')).forEach(function (el) {
      if (el.closest('.capsule-gallery-arrow')) return;
      if (el.classList && el.classList.contains('capsule-media-action')) return;
      if (el.closest && el.closest('.capsule-media-action')) return;
      if (el.closest && el.closest('.capsule-video-modal')) return;
      el.setAttribute('aria-hidden', 'true');
      setImportant(el, 'display', 'none');
      setImportant(el, 'visibility', 'hidden');
      setImportant(el, 'opacity', '0');
      setImportant(el, 'width', '0');
      setImportant(el, 'height', '0');
      setImportant(el, 'min-width', '0');
      setImportant(el, 'min-height', '0');
      setImportant(el, 'max-width', '0');
      setImportant(el, 'max-height', '0');
      setImportant(el, 'padding', '0');
      setImportant(el, 'margin', '0');
      setImportant(el, 'border', '0');
      setImportant(el, 'pointer-events', 'none');
    });
  }

  function run() {
    fixPrices(document);
    hideVideoPlayOverlays(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', run);
  setTimeout(run, 500);
  setTimeout(run, 1500);
  setTimeout(run, 3000);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        fixPrices(node);
        hideVideoPlayOverlays(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
